import {
    chakra,
    Flex
} from '@chakra-ui/react';

export const ModalWrapper = chakra(Flex, {
    label: 'ModalWrapper',
    baseStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        minW: '400px',
        minH: '300px',
        fontSize: '24px',
        padding: '20px',
        border: '1px solid var(--3p-colors-neutral-500)',
        borderRadius: '10px',
        bgColor: 'neutral.50',
        color: 'neutral.900',
        ['& > *']: { mb: '10px' },
        ['h3']: {
            mb: '10px',
            mt: '10px',
            fontSize: '18px'
        },
        ['p']: { fontSize: '16px' }
    }
});
